import { useMutation, useQuery, useQueryClient, type QueryClient } from '@tanstack/react-query';

/**
 * OPP data must always be scoped by OpenPenPalRuntimeProviders. Failing closed
 * avoids silently sharing a process-wide fallback cache across accounts.
 */
export function useOppQueryClient(): QueryClient {
  return useQueryClient();
}

export const useOppQuery = ((options: Parameters<typeof useQuery>[0]) =>
  useQuery(options, useOppQueryClient())) as typeof useQuery;

export const useOppMutation = ((options: Parameters<typeof useMutation>[0]) =>
  useMutation(options, useOppQueryClient())) as typeof useMutation;
